import { ReactElement } from 'react';
import styles from './StudentsMIPHero.module.scss';
import {
  Button,
  TextUnderlineDecoration,
  Typography,
} from '../../../1_shared/ui';
import StudentCard from '1_shared/assets/images/StudentMipCard.webp';
import useMessage from 'antd/es/message/useMessage';

// TODO: Заменить значение константы на соответствующий промокод
const PROMOCODE_FOR_MIP_STUDENTS = 'STUDENT320';

const StudentsMIPHero = (): ReactElement => {
  const [messageApi, contextHolder] = useMessage();

  const headerContent = (
    <Typography type={'h1'} className={styles.headerText}>
      Спецпредложение для{' '}
      <TextUnderlineDecoration>
        <Typography type={'h1'} className={styles.headerFragment}>
          студентов
        </Typography>{' '}
        <Typography type={'italic'}>МИП</Typography>
      </TextUnderlineDecoration>
    </Typography>
  );

  const handleCopyPromoCode = async () => {
    try {
      await navigator.clipboard.writeText(PROMOCODE_FOR_MIP_STUDENTS);

      messageApi.open({
        type: 'success',
        content: 'Промокод скопирован в буфер обмена!',
        duration: 15,
      });
    } catch (error) {
      messageApi.open({
        type: 'warning',
        content: 'Не удалось скопировать промокод',
        duration: 15,
      });
    }
  };

  return (
    <div className={styles.root}>
      {contextHolder}
      <div className={styles.content}>
        <section className={styles.heroInfo}>
          {headerContent}
          <div className={styles.description}>
            <Typography type={'italic'} className={styles.discountInfo}>
              Скидка 20%
            </Typography>
            <Typography className={styles.details}>
              3 сессии с любым специалистом на выбор со скидкой, только для
              новых клиентов
            </Typography>
          </div>
          <Button
            className={styles.copyPromoCode}
            onClick={handleCopyPromoCode}
          >
            СКОПИРОВАТЬ ПРОМОКОД
          </Button>
        </section>
        <img
          src={StudentCard}
          alt="subscription-card"
          className={styles.studentCard}
        />
      </div>
    </div>
  );
};

export default StudentsMIPHero;
